import { Hero } from './Hero';
import { Awards } from './Awards';
import { Reviews } from './Reviews';
import { Services } from './Services';
import { Technology } from './Technology';
import { Benefits } from './Benefits';
import { Contact } from './Contact';

export { Contact, Hero, Awards, Reviews, Services, Technology, Benefits };
